export default __webpack_public_path__ + "static/media/edit-outline.f5754d37.svg";